module.exports = __webpack_public_path__ + "media/application/images/ui/corner-badge-deal-75e6c266b5e0a6405f460ec44e79cbbb.png";